<template>
    <div id="reset-frame" ref="reset-frame">
        <div class="container is-max-desktop auth-card columns">

            <div class="column left-side">
                <h1>
                    <strong>my</strong>247ed.com
                </h1>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fas fa-fw fa-2x fa-lock-keyhole"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Reset Password</h6>

                            <div v-if="valid">
                                <p class="mb-5">Please choose a new password for your login.</p>

                                <b-field label-position="inside">
                                    <template #label>New Password <span class="required-flag">*</span></template>
                                    <b-input v-model="newPassword"></b-input>
                                </b-field>
                            </div>
                            <div v-else>
                                <p class="mb-5">The login request is no longer valid.  Please <router-link to="/assistance">try again</router-link> or contact <a href="mailto:support@my247ed.com">support@my247ed.com</a> for additional help.</p>
                            </div>
                        </div>
                    </div>
                    <div class="columns mb-5">
                        <div class="column">
                        </div>
                        <div class="column is-3 has-text-right">
                            <b-button type="is-primary" expanded icon-left="check" @click="resetPassword" :disabled="!newPassword || !valid">Set Password</b-button>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../http_client";

    export default {
        props: ['code'],
        data: function() {
            return {
                processing: false,
                newPassword: '',
                valid: true,
                reason: ''
            };
        },
        methods: {
            resetPassword() {
                if (!this.processing) {
                    this.processing = true;
                    http.post('app/users/reset', {code: this.code, password: this.newPassword}, {force: true}).then(response => {
                        this.$router.push('/');
                        this.$notify('success', 'Password Reset', 'Your password has been reset.  Please login.', {duration: 10000, permanent: false});

                    }).catch(err => {
                        if (err) console.log(err.response);
                        window.alert(err.response.data + ' If you need additional help please contact us at support@my247ed.com.');
                        this.processing = false;
                        this.valid = false;
                    });
                }
            },
        },
        mounted() {
            http.post('app/users/reset', {code: this.code}, {force: true}).then(response => {
                this.valid = response.data.valid;
                this.reason = response.data.reason;
            }).catch(err => {
                if (err) console.log(err.response);
                window.alert('An error occurred. If you need additional help please contact us at support@my247ed.com.');
                this.processing = false;
            });
        }
    };
</script>

<style lang="scss">
    #reset-frame {
        display: flex;
        min-height: 100vh;
        align-items: center;
        justify-content: center;
        background: #224C74 radial-gradient(#336699, #1e385c);

        .auth-card {
            margin: 4rem 2rem 8rem;
            border-radius: 8px;
            box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);

            .left-side {
                background-color: #FFFFFF;
                padding: 4rem 3.5rem 4rem 3.5rem;
                border-radius: 5px;
                color: #666666;

                strong {
                    color: #484848;
                }

                h1 {
                    font-weight: normal;
                    font-size: 2.6rem !important;
                    color: #282828;
                    margin-bottom: 1.5rem;
                    letter-spacing: -1px;

                    strong {
                        color: #336699;
                        font-weight: 900;
                    }

                    @media (max-width: 768px) {
                        font-size: 2.2rem !important;
                        margin-bottom: 1rem;
                    }
                }

                > p {
                    font-size: 1.2rem;
                    line-height: 1.7rem;
                }

                .is-size-7 {
                    font-size: 0.85rem !important;
                }

                .signup {
                    border-top: 1px solid #e9e9e9;
                    padding-top: 1.5rem;
                    margin-top: 4rem;

                    .button {
                        padding-left: 1.3rem;
                    }

                    @media (max-width: 768px) {
                        margin-top: 2rem;
                    }
                }

                @media (max-width: 768px) {
                    border-radius: 5px;
                    padding: 3rem 1rem 2.5rem 1rem;
                    box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
                }
            }


            h4 {
                font-size: 1.2rem;
                margin-top: 1.5rem;
                margin-bottom: 2rem;
                padding-bottom: 0.8rem;

                i {
                    color: #336699;
                }

                border-bottom: 1px dashed #ddd;
            }

            @media (max-width: 768px) {
                margin: 1rem;
                box-shadow: none;
            }
        }


        @media (max-width: 768px) {
            align-items: normal;
            justify-content: normal;
        }

        span {
            &.beta {
                color: #333;
                border: 1px solid #c2c2c2;
                border-radius: 3px;
                padding: 0 4px;
                font-size: 0.6rem;
                margin-left: 0.5rem;
                vertical-align: super;
                font-weight: normal;
                letter-spacing: normal;
            }
        }
    }

    .required-flag {
        color: red;
    }
</style>
